import { render, staticRenderFns } from "./ketogenesis3.vue?vue&type=template&id=0e839c15&scoped=true&"
import script from "./ketogenesis3.vue?vue&type=script&lang=js&"
export * from "./ketogenesis3.vue?vue&type=script&lang=js&"
import style0 from "./ketogenesis3.vue?vue&type=style&index=0&id=0e839c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e839c15",
  null
  
)

export default component.exports